'use client'

import { useAuthProgress } from '@/feature/account/hooks/useAuthProgress'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Logo } from '@/ui/logos/logo/Logo.client'
import { ProgressBar } from '@/ui/progress-bar/ProgressBar'
import { usePathname } from 'next/navigation'

function isInOnboardingFlow(pathname: string): boolean {
  return pathname.startsWith('/account/create')
}

export function AuthHeader(): React.ReactElement {
  const pathname = usePathname()
  const showProgress = isInOnboardingFlow(pathname)
  const { progressPercentage } = useAuthProgress()
  const { t } = useTranslation(['account'])

  return (
    <div className="sticky top-0 z-[10] flex flex-col items-center justify-center space-y-[.75rem] bg-white p-2">
      <Logo size="s" />
      {showProgress && progressPercentage > 0 && (
        <ProgressBar
          value={progressPercentage}
          aria-label={t('account:create.progress.ariaLabel')}
          id="auth-onboarding-stepper"
          data-testid="auth-onboarding-stepper"
          className="max-w-[14.375rem]"
        />
      )}
    </div>
  )
}
